<div nz-row [nzGutter]="{ md: 24 }">

    <div nz-col nzSpan="8" nzOffset="8">
        <nz-card style="max-width: 423px; margin: 0 auto; display: block;">
            <img src="../../assets/img/logomarca_1.png" class="logomarca" style="width:80%; display:block; margin: 0 auto;" alt="logo">
            <p style="text-align: center; margin-top: 20px;"><strong>Redefinir Senha</strong></p>
            <form nzLayout="vertical" style="margin-top:10px!important;" nz-form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">
                <nz-form-item>
                    <label for="">E-mail:</label>
                    <nz-form-control nzHasFeedback nzErrorTip="Informe um e-mail válido!">

                        <nz-input-group nzPrefixIcon="user">

                            <input type="email" nz-input formControlName="email" placeholder="Digite o seu e-mail" />
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
                <div nz-row [nzGutter]="{ md: 24 }">
                    <div nz-col nzSpan="12">
                        <button nz-button nzBlock class="login-form-button login-form-margin" [routerLink]="['/login']" routerLinkActive="router-link-active" [nzType]="'default'">Cancelar</button>
                    </div>
                    <div nz-col nzSpan="12">
                        <button nz-button nzBlock class="login-form-button login-form-margin" nzType="primary">Solicitar Redefinição</button>
                    </div>
                </div>

            </form>
        </nz-card>
    </div>
</div>